import { Spin } from "antd"
import { LoadingOutlined } from '@ant-design/icons'

const Fallback = () => {
    return (
        <div className='flex items-center justify-center h-screen gap-4'>
            <span>Loading</span>
            <Spin
                indicator={<LoadingOutlined className='text-[24px]' spin />}
            />
        </div>
    )
}

export default Fallback